import React from 'react';
import { createUseStyles } from '../../../../../../../../theming';
import Hidden from '../../../../../../Hidden';

const useStyles = createUseStyles({
  lost: {
    borderLeft: '4px solid #5b4c91',
  },
  nego: {
    borderLeft: '4px solid #f57c73',
  },
  legend: {
    '& span': {
      fontSize: 13,
      marginRight: 30,
      paddingLeft: 5,
    },
  },
});

const Legend = () => {
  const classes = useStyles();

  return (
    <Hidden mdDown>
      <div className={classes.legend}>
        <span className={classes.lost}>Perdue</span>
        <span className={classes.nego}>En négociation</span>
      </div>
    </Hidden>
  );
};

export default Legend;
